/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: @loopback/repository-json-schema#Optional<Omit<FilePermission, \'id\'>, \'fileId\'>, schemaOptions: { title: \'NewFilePermissionInFolderFile\', exclude: [ \'id\' ], optional: [ \'fileId\' ] })
 */
export interface NewFilePermissionInFolderFile { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    /**
     * Nivel de permiso para el archivo
     */
    permissionLevel: NewFilePermissionInFolderFile.PermissionLevelEnum;
    fileId?: string;
    userId?: number;
    companyId?: string;
}
export namespace NewFilePermissionInFolderFile {
    export type PermissionLevelEnum = 'viewer' | 'editor';
    export const PermissionLevelEnum = {
        Viewer: 'viewer' as PermissionLevelEnum,
        Editor: 'editor' as PermissionLevelEnum
    };
}


